module.exports = __webpack_public_path__ + "img/sign-out-regular.31997997.svg";